/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import PasswordSupportMainDumb from './PasswordSupportMainDumb';
import {
  resetPasswordSupportSection,
  showPasswordSupportLinkSection,
  showPasswordSupportResetSection,
  showPasswordSupportContactSection,
} from 'src/shared/app/authentication/action/support/uiSupportActions';
import {
  isPasswordSupportLinkSectionShown,
  isPasswordSupportResetSectionShown,
  isPasswordSupportContactSectionShown,
} from 'src/shared/app/authentication/selector/support/uiAuthenticationSupportSelectors';
import withFeatureDecisions from 'src/shared/app/feature/component/withFeatureDecisions';
import withMount from 'src/shared/app/base/component/hoc/withMount';

type Props = {
  featureDecisions: Object,
};

const mapStateToProps = (
  state: Object,
  { featureDecisions }: Props,
): Object => ({
  isLoginLinkDisabled: featureDecisions.isLoginLinkShownInSupport(),
  showLink: isPasswordSupportLinkSectionShown(state),
  showReset: isPasswordSupportResetSectionShown(state),
  showContact: isPasswordSupportContactSectionShown(state),
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (stateProps: Object, { dispatch }: Object): Object => ({
  ...stateProps,
  handleMount() {
    dispatch(resetPasswordSupportSection());
  },
  handleLoginLinkClick() {
    dispatch(showPasswordSupportLinkSection());
  },
  handleResetPasswordClick() {
    dispatch(showPasswordSupportResetSection());
  },
  handleContactClick() {
    dispatch(showPasswordSupportContactSection());
  },
  handleBack() {
    dispatch(resetPasswordSupportSection());
  },
});

export default compose(
  withFeatureDecisions,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withMount,
)(PasswordSupportMainDumb);
